import React, { useRef, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import image from "../../../assest/images/logo.png";
import { colors, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useCustomer } from "../../../context/apiContext/CustomerContext";
import { jsPDF } from "jspdf";
import QuationsListTables from "../QuationsListTables";
import { useNavigate, useParams } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { getQuotationDetail } from "../quationQuery";
import { AllProductDetailsQuery } from "../../../lib/graphQL/graphQuery";
import "./pdf.css";
import _ from "lodash";
import EmailIcon from "@mui/icons-material/Email";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Margin } from "@mui/icons-material";

const qoutationpdf = gql`
  query qoutationpdf($id: String!) {
    getQuotationDetail(id: $id) {
      id
      quoteDate
      user {
        username
        email
      }
      relatedName
      billingAddress
      discount
      quotationproductsSet {
        productName {
          productName
          description
          HSNNumber
          SKU
          Tax
        }
        cgstTax
        cgstTaxamount
        sgstTax
        sgstTaxamount
        quantity
        calculatedAmount
        productDiscount
      }
    features
      termsAndConditions
      totalCgstAmount
      totalSgstAmount
      subTotal
      totalAmount
    }
  }
`;
const convertToWords = (num) => {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  if (num === 0) return "Zero";

  const convertHundreds = (n) => {
    let result = "";
    if (n > 99) {
      result += ones[Math.floor(n / 100)] + " Hundred ";
      n = n % 100;
    }
    if (n > 19) {
      result += tens[Math.floor(n / 10)] + " ";
      n = n % 10;
    }
    result += ones[n];
    return result.trim();
  };

  let words = "";

  if (num >= 10000000) {
    // Crores
    words += convertHundreds(Math.floor(num / 10000000)) + " Crore ";
    num = num % 10000000;
  }
  if (num >= 100000) {
    // Lakhs
    words += convertHundreds(Math.floor(num / 100000)) + " Lakh ";
    num = num % 100000;
  }
  if (num >= 1000) {
    // Thousands
    words += convertHundreds(Math.floor(num / 1000)) + " Thousand ";
    num = num % 1000;
  }
  words += convertHundreds(num);

  words = "Indian Rupees " + words.trim() + " Only";
  return words.trim();
};

const email = "";
const subject = "Here’s the PDF you requested";
const body = "Hello,\n\nPlease Attach The PDF\n\nBest regards.";
const pdfLink = "/path/to/your-file.pdf";

const handleEmailClick = () => {
  window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
};

const HandleDownloadPdf = () => {
  const [quationData, setQuation] = useState({
    id: "",
    quoteDate: "",
    billingAddress: "",
    // features: "",
  });

  const [customerData, setCustomerData] = useState({
    GSTNumber: "",
    legalName: "",
    subTotal: "",
    totalAmount: "",
    totalSgstAmount: "",
    totalCgstAmount: "",
    billingAddress: "",
    features: "",
    relatedName: "",
    termsAndConditions: "",
  });

  const [userData, setUserData] = useState({
    username: "",
    email: "",
  });

  const [quotationProductsSet, setQuotationProductsSet] = useState([]);
  const [data, setData] = useState(null);
  const { rowdata } = useCustomer();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      fetchValue();
    }
  }, [id]);

  const fetchValue = () => {
    const res = request(BASEURL, qoutationpdf, { id: id })
      .then((res) => {
        const Q = res.getQuotationDetail;

        setData(Q);
        setQuation({
          id: Q.id,
          quoteDate: Q.quoteDate,
          totalAmount: Q.totalAmount,
          subTotal: Q.subTotal,
          totalCgstAmount: Q.totalCgstAmount,
          totalSgstAmount: Q.totalSgstAmount,
          billingAddress: Q.billingAddress,
          features: Q.features,
          relatedName: Q.relatedName,
          termsAndConditions: Q.termsAndConditions,
        });

        setUserData({
          username: Q.user.username,
          email: Q.user.email,
        });
        const products = Q.quotationproductsSet.map((product) => ({
          productName: product.productName.productName || "",
          description: product.productName.description || "",
          HSNNumber: product.productName.HSNNumber || "",
          SKU: product.productName.SKU || "",
          Tax: product.productName.Tax || "",
          quantity: product.quantity || "",
          calculatedAmount: product.calculatedAmount || "",
          // amount: product.amount || "",
          totalproductamount: product.totalproductamount || "",
          cgstTax: product.cgstTax || "",
          cgstTaxamount: product.cgstTaxamount || "",
          sgstTax: product.sgstTax || "",
          sgstTaxamount: product.sgstTaxamount || "",
        }));

        setQuotationProductsSet(products);
      })

      .catch((err) => {});
  };

  const pdfRef = useRef();
  const handleDownloadPdf = () => {
    const doc = new jsPDF();

    doc.html(pdfRef.current, {
      callback: function (doc) {
        doc.save("quotation.pdf");
      },
      margin: [10, 10, 10, 10],
      x: 10,
      y: 10,
      width: 170,
      windowWidth: 800,
    });
  };

  useEffect(() => {
    if (rowdata) {
      handleDownloadPdf();
    }
  }, [rowdata]);

  return (
    <DashboardLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          padding: "0px 20px",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <div style={{ display: "flex" }}>
          <div onClick={handleDownloadPdf} style={{ marginRight: "30px" }}>
            <button class="Btn">
              <svg
                class="svgIcon"
                viewBox="0 0 384 512"
                height="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
              </svg>
              <span class="icon2"></span>
              <span class="tooltip">Download Pdf</span>
            </button>
          </div>
          <div>
            <button class="Btn" onClick={handleEmailClick}>
              <EmailIcon sx={{ fontSize: "40px", transform: "scale(1.5)" }} />
              <span class="tooltip">Send Mail</span>
            </button>
          </div>
        </div>
      </div>
      <div style={{ transform: "scale(0.8)", marginTop: "-100px" }}>
        <Box
          sx={{
            display: "flex",

            minHeight: "100vh",
          }}
          ref={pdfRef}
        >
          <Box
            sx={{
              padding: 4,
              borderRadius: "8px",
              maxWidth: "800px",
              width: "100%",
              backgroundColor: "#fff",
            }}
          >
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid size={6}>
                <img
                  src={image}
                  alt="Company Logo"
                  style={{ height: "70px", marginTop: "50%" }}
                />
              </Grid>
              <Grid size={6} sx={{ marginLeft: "3%" }}>
                <Typography sx={{ fontSize: "20px" }}>
                  <strong className="courier-prime-bold">
                    KEEL INFO SOLUTION PRIVATE<br></br>LIMITED
                  </strong>
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: "500" }}
                  className="courier-prime-regular"
                >
                  73 ESIC Nagar, 150 ft Agaram Main Road,
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: "500" }}
                  className="courier-prime-regular"
                >
                  Thiruvanchery,
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: "500" }}
                  className="courier-prime-regular"
                >
                  Chennai - 600126
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: "500" }}
                  className="courier-prime-regular"
                >
                  Tamilnadu, India.
                </Typography>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: "500" }}
                  className="courier-prime-regular"
                >
                  GSTIN{" "}
                  <strong>
                    <span>: </span>{" "}
                  </strong>
                  <span>33AAJCK7889H1ZX</span>
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                // sx={{textAlign:'end'}}
                sx={{
                  marginLeft: "76%",
                  marginBottom: "2%",
                  marginTop: "-60px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "30px",
                    marginTop: "7px",
                    fontWeight: "900px",
                  }}
                >
                  <strong className="courier-prime-bold">Quotation</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ marginTop: "-10px" }}>
                <hr style={{ width: "108%", marginLeft: "-4%" }}></hr>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                padding: "0px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  padding: "10px 0px",
                  width: "60%",
                  paddingRight: "20px",
                  borderRight: "solid 1px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                  className="courier-prime-regular"
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Quotation No
                  </span>
                  <strong>
                    {" "}
                    <span>: </span>
                  </strong>
                  <strong
                    style={{
                      fontSize: "17px",
                      fontWeight: "600",
                      marginLeft: "5px",
                    }}
                  >
                    <strong
                      className="courier-prime-bold"
                      style={{ fontWeight: "900px" }}
                    >
                      {quationData.id}
                    </strong>
                  </strong>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                  className="courier-prime-regular"
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Quotation Date
                  </span>
                  <strong>
                    <span>: </span>
                  </strong>
                  <strong
                    style={{
                      fontSize: "17px",
                      fontWeight: "600",
                      marginLeft: "5px",
                    }}
                  >
                    <strong
                      className="courier-prime-bold"
                      style={{ fontWeight: "900px" }}
                    >
                      {new Date(quationData.quoteDate).toLocaleDateString("en-GB")}
                    </strong>
                  </strong>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                  className="courier-prime-regular"
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Contact
                  </span>
                  <strong>
                    <span>: </span>
                  </strong>
                  <strong
                    style={{
                      fontSize: "17px",
                      fontWeight: "600",
                      marginLeft: "5px",
                    }}
                  >
                    <strong
                      className="courier-prime-bold"
                      style={{ fontWeight: "900px" }}
                    >
                      {data?.user.email}
                    </strong>
                  </strong>
                </Typography>
              </Box>

              <Box
                sx={{ width: "38%", marginLeft: "10px", padding: "10px 0px" }}
                className="courier-prime-regular"
              >
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                  className="courier-prime-regular"
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Place of Supply
                  </span>
                  <strong>
                    {" "}
                    <span>: </span>
                  </strong>{" "}
                  <strong
                    style={{
                      fontSize: "17px",
                      fontWeight: "600",
                      marginLeft: "5px",
                    }}
                  >
                    <strong
                      className="courier-prime-bold"
                      style={{ fontWeight: "900px" }}
                    >
                      Tamil Nadu
                    </strong>
                  </strong>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                  className="courier-prime-regular"
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                  >
                    Sales person
                  </span>
                  <strong>
                    <span>: </span>
                  </strong>{" "}
                  <strong
                    style={{
                      fontSize: "17px",
                      fontWeight: "600",
                      marginLeft: "5px",
                    }}
                  >
                    <strong
                      className="courier-prime-bold"
                      style={{ fontWeight: "900px" }}
                    >
                      {_.capitalize(data?.user?.username)}
                    </strong>
                  </strong>
                </Typography>
              </Box>
            </Box>

            {/* <hr></hr> */}
            <Box
              sx={{
                backgroundColor: "lightgray",
                width: "108%",
                marginLeft: "-4%",
                border: "1px solid black",
              }}
            >
              <Grid>
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bolder",
                    marginLeft: "2%",
                  }}
                  className="courier-prime-bold"
                >
                  Bill To
                </Typography>
              </Grid>
            </Box>

            <hr style={{ width: "108%", marginLeft: "-4%" }}></hr>
            <Box sx={{ padding: "8px 0px" }}>
              <Typography
                sx={{ fontSize: "90%" }}
                className="courier-prime-regular"
              ></Typography>
              <Typography
                sx={{ fontSize: "80%" }}
                className="courier-prime-regular"
              >
                <strong> {quationData.relatedName}</strong>
                <Typography className="courier-prime-regular">
                  {quationData.billingAddress}
                </Typography>
              </Typography>
              <strong
                className="courier-prime-bold"
                style={{ fontWeight: "900px" }}
              >
                Product:
              </strong>
              <table
                style={{
                  width: "108%",
                  borderCollapse: "collapse",
                  marginLeft: "-4%",
                  marginTop: "1%",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#e0e0e0" }}>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      S.No.
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "2px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Item & Description
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "3px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      HSN/SKU
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Qty
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Rate
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",

                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      CGST
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      SGST
                    </th>
                    <th
                      rowSpan="2"
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      %
                    </th>
                    <th
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Amt
                    </th>
                    <th
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      %
                    </th>
                    <th
                      style={{
                        border: "2px solid #a1a1a1",
                        padding: "4px",
                        fontSize: "15px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      Amt
                    </th>
                  </tr>
                </thead>
                <tbody className="courier-prime-regular">
                  {quotationProductsSet.length > 0 ? (
                    quotationProductsSet.map((product, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{index + 1}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>
                            {product.productName}
                            <br />
                            {product.description}
                          </center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>
                            {product.HSNNumber}/{product.SKU}
                          </center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.quantity}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.calculatedAmount}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.cgstTax}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.cgstTaxamount}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.sgstTax}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{product.sgstTaxamount}</center>
                        </td>
                        <td
                          style={{
                            border: "2px solid #a1a1a1",
                            padding: "4px",
                            fontSize: "15px",
                          }}
                        >
                          <center>{quationData.subTotal}</center>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <center>
                      <tr>
                        <td colSpan="10">No products available.</td>
                      </tr>
                    </center>
                  )}
                </tbody>
              </table>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Typography
                  sx={{ fontSize: "75%", marginTop: "2%" }}
                  className="courier-prime-regular"
                >
                  Total In Words :
                </Typography>
                <strong
                  style={{
                    fontSize: "16px",
                    display: "block",
                    marginTop: "5px",
                    fontStyle: "italic",
                  }}
                  className="courier-prime-bold"
                >
                  {quationData.totalAmount
                    ? convertToWords(parseFloat(quationData.totalAmount))
                    : "Loading..."}
                </strong>

                <Typography
                  sx={{ fontSize: "16px", marginTop: "8%", fontWeight: "600" }}
                  className="courier-prime-bold"
                >
                  <strong
                    className="courier-prime-bold"
                    style={{ fontWeight: "900px" }}
                  >
                    {" "}
                    Notes:
                  </strong>
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", marginTop: "3%" }}
                  className="courier-prime-regular"
                >
                  Looking forward for your business
                </Typography>
              </Box>
              <Box
                sx={{
                  borderLeft: "1px solid #a1a1a1 ",
                  borderBottom: "1px solid #a1a1a1",
                  padding: "6px",
                  marginTop: "6px",
                  marginLeft: "13em",
                }}
              >
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                >
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "18px", fontWeight: "600" }}
                    >
                      <strong
                        className="courier-prime-bold"
                        style={{ fontWeight: "900px" }}
                      >
                        {" "}
                        Sub Total
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "15px", marginLeft: "100px" }}
                      className="courier-prime-regular"
                    >
                      {quationData.subTotal}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: "600" }}
                      className="courier-prime-bold"
                    >
                      <strong
                        className="courier-prime-bold"
                        style={{ fontWeight: "900px" }}
                      >
                        {" "}
                        CGST
                        <span
                          style={{ fontSize: "15px" }}
                          className="courier-prime-regular"
                        >
                          %
                        </span>
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "15px", marginLeft: "100px" }}
                      className="courier-prime-regular"
                    >
                      {quationData.totalCgstAmount}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: "600" }}
                      className="courier-prime-bold"
                    >
                      <strong
                        className="courier-prime-bold"
                        style={{ fontWeight: "900px" }}
                      >
                        {" "}
                        SGST
                        <span
                          style={{ fontSize: "13px" }}
                          className="courier-prime-bold"
                        >
                          %
                        </span>
                      </strong>{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "15px", marginLeft: "100px" }}
                      className="courier-prime-regular"
                    >
                      {quationData.totalSgstAmount}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{ justifyContent: "end" }}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "18px", fontWeight: "600" }}
                      className="courier-prime-bold"
                    >
                      <strong
                        className="courier-prime-bold"
                        style={{ fontWeight: "900px" }}
                      >
                        {" "}
                        Total
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "15px", marginLeft: "100px" }}
                      className="courier-prime-regular"
                    >
                      {quationData.totalAmount}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: "15px", marginTop: "1%" }}
                className="courier-prime-bold"
              >
                <strong>
                  {" "}
                  BANK DETAILS :<hr style={{ width: "17%" }}></hr>
                </strong>
              </Typography>
              <Grid size={6} sx={{ marginTop: "2%" }}>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "16px" }}
                  className="courier-prime-bold"
                >
                  <strong className="courier-prime-bold">Account Name</strong>:
                  Keel Info Solution Private Limited
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "16px" }}
                  className="courier-prime-bold"
                >
                  <strong>ACC No</strong>: 99918514211110
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "16px" }}
                  className="courier-prime-bold"
                >
                  <strong>IFSC Code</strong>: HDFC0008355
                </Typography>
              </Grid>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: "16px", marginTop: "1%" }}
                className="courier-prime-regular"
              >
                <strong
                  className="courier-prime-bold"
                  style={{ fontWeight: "900px" }}
                >
                  {" "}
                  Terms & Conditions :
                </strong>
              </Typography>
              <Typography
  sx={{ fontSize: "15px" }}
  className="courier-prime-regular"
>
  •This is a system-generated document; hence, a signature is not required.
</Typography>
{/* <Typography
  sx={{
    fontSize: "15px",
    padding: 0,
    margin: 0,
  }}
  className="courier-prime-regular"
  component="div"
>
  <ul
    style={{
      paddingLeft: "20px",
      margin: 0,
      listStyleType: "disc", // This ensures bullets only show on the <ul>
    }}
  >
    {quationData?.termsAndConditions
      ?.split("\n")
      ?.filter((value) => value.trim() !== "")
      ?.map((value, index) => (
        <li key={index} style={{ marginBottom: "5px" }}>
          {value.trim()}
        </li>
      ))}
  </ul>
</Typography> */}

<Typography
                sx={{ fontSize: "16px", marginTop: "1%" }}
                className="courier-prime-regular"
              >
                
                  
                {quationData?.termsAndConditions}
               
              </Typography>


            </Box>
          </Box>
        </Box>
      </div>
      <div style={{ transform: "scale(0.8)", marginTop: "-100px" }}>
          <Box
          sx={{
            display: "flex",

            minHeight: "100vh",
          }}
          ref={pdfRef}
        >
          <Box
            sx={{
              padding: 4,
              borderRadius: "8px",
              maxWidth: "800px",
              height: "1123px",
              width: "100%",
              backgroundColor: "#fff",
            }}
          >
            <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              
            </Grid>

            <Grid item xs={12} sx={{ marginTop: "30px" }}>
                
            </Grid>
            {/* <div 
            style={{
              marginLeft: "20px",
              marginTop: "20px",
            }}> */}
                <p
                style={{
                  marginLeft: "20px",
                  marginTop: "20px",
                }}
                dangerouslySetInnerHTML={{ __html: quationData?.features }}
                className="my-4 lg:text-lg md:text-lg sm:text-md max-sm:text-md leading-8 carrer-text"
              ></p>
            {/* </div> */}

          </Box>
          
          </Box>
      </div>
    </DashboardLayout>
  );
};

export default HandleDownloadPdf;
